import { createUseStyles } from 'react-jss'

export default createUseStyles({
  suggestionsContainer: ({ showAvatar }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    padding: showAvatar ? '0 20px 10px 50px' : '0 20px 10px 5px',
    overflow: 'visible',
    overflowX: 'auto'
  })
})
